module.exports = __webpack_public_path__ + "static/media/token.32f300b5.png";